import React from 'react';
import cls from 'classnames';

export enum LogoStyles {
  KNOCKOUT = 'knockout',
  OUTLINE = 'outline',
  APP = 'app',
}
export enum LogoOrientation {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
}
export enum LogoColor {
  BLACK = 'black',
  COLOR = 'color',
  WHITE = 'white',
}
export interface ILogoProps {
  onlySymbol?: boolean;
  orientation: LogoOrientation;
  style: LogoStyles;
  color: LogoColor;
  height?: number;
}
export const LogoComp: React.FC<ILogoProps> = (props) => {
  const { onlySymbol, orientation, style, color, height } = props;
  return (
    <>
      {!onlySymbol && style !== LogoStyles.APP && orientation === LogoOrientation.HORIZONTAL && (
        <svg
          width={height ? (height * 782) / 121 : (24 * 782) / 121}
          height={height ? height : 24}
          viewBox="0 0 782 121"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            {style === LogoStyles.OUTLINE && (
              <>
                <path
                  d="M74.2203 0C33.2287 0.00389908 -0.0271405 18.8871 1.66208e-05 60.4981C-0.0271405 102.109 33.2287 120.992 74.2203 120.996C115.212 120.992 148.468 102.109 148.441 60.4981C148.468 18.8871 115.212 0.00389908 74.2203 0ZM123.293 101.672C111.321 110.515 94.3515 115.19 74.2242 115.19C54.0931 115.19 37.1238 110.512 25.1514 101.672C12.2867 92.1702 5.76896 78.3168 5.77672 60.4942C5.76508 42.6793 12.2828 28.8259 25.1514 19.3238C37.1238 10.4846 54.0892 5.80962 74.2203 5.80572C94.3515 5.80572 111.321 10.4846 123.293 19.3238C136.158 28.8259 142.676 42.6793 142.664 60.502C142.676 78.3168 136.158 92.1702 123.293 101.672Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M84.8271 50.5203L98.6539 36.624C96.59 34.4873 94.2506 32.6236 91.6901 31.0834L77.7275 45.1162C75.3376 47.5141 74.6315 51.0896 75.9234 54.2244C77.2153 57.3593 80.2298 59.3829 83.605 59.3829H108.279C108.182 56.3066 107.682 53.3355 106.828 50.5164H84.8271V50.5203Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M64.2653 49.7834L50.4811 35.93C48.3551 38.0004 46.4968 40.3515 44.9683 42.9249L58.8921 56.9187C60.4866 58.5212 62.601 59.3673 64.7619 59.3673C65.8327 59.3673 66.9189 59.1568 67.9548 58.7279C71.074 57.4334 73.0875 54.3999 73.0875 51.0077V26.272C70.0265 26.3694 67.0702 26.8763 64.2653 27.738V49.7834Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M80.4005 62.2409C77.2852 63.5393 75.2678 66.5689 75.2678 69.9611V94.7319C78.3249 94.6422 81.2851 94.1432 84.09 93.2893V71.1854L97.9324 85.0973C100.062 83.0269 101.924 80.6796 103.453 78.1102L89.4671 64.054C87.0773 61.6522 83.5197 60.9425 80.4005 62.2409Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M64.7464 61.5781H40.1576C40.2507 64.6544 40.7473 67.6255 41.6008 70.4446H63.5282L49.7285 84.3175C51.7886 86.4542 54.1241 88.3257 56.6769 89.8659L70.6278 75.8487C73.0138 73.4469 73.7199 69.8714 72.428 66.7365C71.1361 63.6056 68.1216 61.5781 64.7464 61.5781Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
              </>
            )}
            {style === LogoStyles.KNOCKOUT && (
              <>
                <path
                  d="M74.4101 0C33.3136 0.00389908 -0.0272709 18.8871 -4.43719e-05 60.4981C-0.0272709 102.109 33.3136 120.992 74.4101 120.996C115.507 120.992 148.847 102.109 148.82 60.4981C148.847 18.8871 115.507 0.00389908 74.4101 0ZM70.8084 75.8487L56.8217 89.8659C54.2625 88.3258 51.9171 86.4542 49.8556 84.3175L63.6906 70.4446H41.7071C40.8514 67.6256 40.3536 64.6545 40.2602 61.5781H64.9119C68.2997 61.5781 71.3218 63.6056 72.6131 66.7366C73.9083 69.8714 73.2005 73.4469 70.8084 75.8487ZM73.2744 51.0038C73.2744 54.396 71.2557 57.4295 68.1285 58.724C67.09 59.1568 66.0049 59.3634 64.9275 59.3634C62.761 59.3634 60.6412 58.5173 59.0427 56.9148L45.0832 42.921C46.6196 40.3476 48.4826 37.9965 50.6102 35.9261L64.4296 49.7795V27.7341C67.2417 26.8724 70.2055 26.3694 73.2744 26.2681V51.0038ZM98.1827 85.0934L84.305 71.1815V93.2854C81.4929 94.1393 78.5291 94.6384 75.4603 94.728V69.9572C75.4603 66.565 77.4828 63.5315 80.6061 62.237C83.7332 60.9387 87.2999 61.6483 89.6959 64.0501L103.718 78.1063C102.181 80.6758 100.318 83.023 98.1827 85.0934ZM83.8227 59.3829C80.4388 59.3829 77.4128 57.3593 76.1215 54.2244C74.8263 51.0896 75.5342 47.5141 77.9301 45.1162L91.9284 31.0834C94.4955 32.6236 96.8409 34.4873 98.9101 36.6201L85.0479 50.5164H107.105C107.961 53.3355 108.467 56.3066 108.56 59.3829H83.8227Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M621.527 47.5492V94.8996H636.269V47.5843C634.083 48.4031 631.621 48.8398 628.945 48.8398C626.269 48.8398 623.737 48.3914 621.527 47.5492Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M220.134 54.3921L208.917 52.3607C200.267 50.6022 196.482 48.2979 196.482 44.3676C196.482 39.3573 202.293 34.8851 209.998 34.8851C218.785 34.8851 225.405 39.4938 226.354 45.9935L239.597 43.0107C237.299 31.4968 225.541 23.4998 210.271 23.4998C194.187 23.4998 182.97 32.3078 182.97 45.3112C182.97 56.0141 189.322 61.7068 203.919 64.5492L215 66.4481C225.677 68.2065 230.407 71.1893 230.407 75.6577C230.407 81.6194 223.11 85.8187 213.511 85.8187C202.293 85.8187 194.184 79.857 193.238 71.3219L179.454 73.4898C179.995 80.9448 183.375 86.9026 189.726 91.1019C196.078 95.3012 203.783 97.4691 213.106 97.4691C230.947 97.4691 244.055 87.8501 244.055 74.4412C244.055 63.6017 237.026 57.6401 220.134 54.3882V54.3921Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M324.933 81.2178H324.797L308.041 26.077H291.686L275.198 80.9487H275.062L259.115 26.077H244.113L266.143 94.8996H284.117L299.659 41.2522H299.932L316.015 94.8996H333.852L355.614 26.077H340.744L324.933 81.2178Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M415.617 36.5071H415.485C409.538 28.2449 401.024 23.4998 390.751 23.4998C371.561 23.4998 357.368 39.0805 357.368 60.4864C357.368 81.8923 371.693 97.473 390.751 97.473C401.16 97.473 409.674 92.7317 415.485 84.1967H415.621V94.8996H429.946V26.077H415.621V36.5071H415.617ZM393.991 84.4696C381.557 84.4696 371.961 74.176 371.961 60.4903C371.961 46.8045 381.421 36.511 393.991 36.511C406.562 36.511 416.158 47.0775 416.158 60.4903C416.158 73.9031 406.835 84.4696 393.991 84.4696Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
              </>
            )}
            <path
              d="M619.942 47.5492V94.8996H634.646V47.5843C632.465 48.4031 630.01 48.8398 627.34 48.8398C624.671 48.8398 622.146 48.3914 619.942 47.5492Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M219.573 54.3921L208.384 52.3607C199.756 50.6022 195.981 48.2978 195.981 44.3676C195.981 39.3572 201.777 34.885 209.463 34.885C218.227 34.885 224.83 39.4937 225.776 45.9974L238.986 43.0146C236.693 31.5006 224.965 23.5036 209.734 23.5036C193.692 23.5036 182.503 32.3116 182.503 45.315C182.503 56.018 188.839 61.7106 203.399 64.5531L214.452 66.4519C225.101 68.2104 229.819 71.1932 229.819 75.6615C229.819 81.6232 222.541 85.8225 212.966 85.8225C201.777 85.8225 193.688 79.8608 192.745 71.3258L178.996 73.4936C179.535 80.9487 182.907 86.9065 189.242 91.1058C195.578 95.3051 203.263 97.473 212.562 97.473C230.358 97.473 243.432 87.8539 243.432 74.445C243.432 63.6056 236.422 57.6439 219.573 54.3921Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M324.104 81.2178H323.969L307.255 26.077H290.942L274.496 80.9487H274.36L258.454 26.077H243.49L265.464 94.8996H283.392L298.895 41.2522H299.166L315.208 94.8996H333L354.707 26.077H339.875L324.104 81.2178Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M414.557 36.5071H414.425C408.493 28.2449 400.001 23.4998 389.755 23.4998C370.613 23.4998 356.456 39.0805 356.456 60.4864C356.456 81.8923 370.745 97.473 389.755 97.473C400.136 97.473 408.629 92.7317 414.425 84.1967H414.561V94.8996H428.849V26.077H414.561V36.5071H414.557ZM392.986 84.4696C380.583 84.4696 371.012 74.176 371.012 60.4903C371.012 46.8045 380.448 36.511 392.986 36.511C405.525 36.511 415.096 47.0775 415.096 60.4903C415.096 73.9031 405.797 84.4696 392.986 84.4696Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M480.618 23.5036C470.24 23.5036 461.748 28.2449 455.812 36.9164H455.68V26.077H441.392V114.114H455.68V84.3331H455.816C461.612 92.8681 470.376 97.4769 480.754 97.4769C499.896 97.4769 514.053 81.8961 514.053 60.4902C514.053 39.0843 499.9 23.5036 480.622 23.5036H480.618ZM477.519 84.4734C464.848 84.4734 455.545 73.9069 455.545 60.4941C455.545 47.0813 464.848 36.5148 477.519 36.5148C490.189 36.5148 499.493 46.8123 499.493 60.4941C499.493 74.176 490.053 84.4734 477.519 84.4734Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M528.469 80.7654C522.673 80.7654 518.762 84.6957 518.762 90.2519C518.762 95.8081 522.941 99.8709 528.469 99.8709C533.998 99.8709 538.176 95.8042 538.176 90.2519C538.176 84.6996 534.265 80.7654 528.469 80.7654Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M591.823 26.077L566.524 55.9323V6.91309H551.828V94.8996H566.524V65.0483L591.823 94.8996H610.216L580.688 60.4903L610.216 26.077H591.823Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M724.714 81.2178H724.582L707.865 26.077H691.555L675.106 80.9487H674.974L659.064 26.077H644.104L666.074 94.8996H684.006L699.508 41.2522H699.776L715.818 94.8996H733.614L755.316 26.077H740.488L724.714 81.2178Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M627.34 21.7997C621.665 21.7997 617.839 25.6481 617.839 31.0834C617.839 36.5188 621.665 40.4997 627.34 40.4997C633.016 40.4997 636.841 36.7839 636.841 31.0834C636.841 25.383 633.016 21.7997 627.34 21.7997Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M765.101 47.5492V94.8996H779.804V47.5843C777.624 48.4031 775.168 48.8398 772.499 48.8398C769.83 48.8398 767.304 48.3914 765.101 47.5492Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M772.499 40.5036C778.171 40.5036 782 36.7878 782 31.0874C782 25.3869 778.175 21.8036 772.499 21.8036C766.823 21.8036 762.998 25.652 762.998 31.0874C762.998 36.5227 766.823 40.5036 772.499 40.5036Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
          </g>
        </svg>
      )}
      {!onlySymbol && style !== LogoStyles.APP && orientation === LogoOrientation.VERTICAL && (
        <svg
          width={height ? (height * 604) / 285 : (24 * 604) / 285}
          height={height ? height : 24}
          viewBox="0 0 604 285"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            {style === LogoStyles.OUTLINE && (
              <>
                <path
                  d="M314.629 79.8353H347.824C347.695 75.6987 347.019 71.7027 345.869 67.9173H316.265L334.868 49.2365C332.089 46.3644 328.942 43.859 325.499 41.7908L306.714 60.6589C303.5 63.8823 302.548 68.6861 304.289 72.9007C306.026 77.1153 310.083 79.8353 314.626 79.8353H314.629Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M289.273 79.8079C290.715 79.8079 292.176 79.5269 293.567 78.9455C297.764 77.2011 300.473 73.127 300.473 68.5651V35.3167C296.354 35.4493 292.374 36.1284 288.605 37.2874V66.9261L270.061 48.3038C267.201 51.0901 264.702 54.2511 262.643 57.7086L281.377 76.5221C283.522 78.6762 286.37 79.8157 289.273 79.8157V79.8079Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M315.275 95.6946L333.896 114.395C336.764 111.613 339.267 108.455 341.326 105.002L322.506 86.1025C319.293 82.8753 314.509 81.9192 310.312 83.6674C306.119 85.4118 303.407 89.4859 303.407 94.0478V127.347C307.522 127.226 311.505 126.555 315.275 125.407V95.6907V95.6946Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M287.614 94.6995L269.051 113.345C271.821 116.221 274.965 118.734 278.4 120.807L297.17 101.962C300.38 98.7346 301.332 93.9308 299.591 89.7162C297.854 85.5055 293.801 82.7816 289.254 82.7816H256.172C256.297 86.9182 256.969 90.9142 258.115 94.6995H287.618H287.614Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M302 162.664C357.15 162.656 401.893 137.271 401.858 81.3338C401.893 25.3929 357.15 0.0078048 302 0C246.85 0.0078048 202.107 25.3929 202.142 81.3299C202.107 137.271 246.85 162.656 302 162.66V162.664ZM235.981 25.9822C252.088 14.0955 274.915 7.8126 302 7.8087C329.085 7.8087 351.912 14.0955 368.019 25.9822C385.327 38.7586 394.098 57.377 394.082 81.3377C394.098 105.287 385.327 123.909 368.019 136.682C351.912 148.568 329.081 154.851 302 154.855C274.915 154.855 252.084 148.568 235.981 136.682C218.673 123.905 209.902 105.287 209.917 81.326C209.902 57.377 218.673 38.7547 235.981 25.9822Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
              </>
            )}
            {style === LogoStyles.KNOCKOUT && (
              <>
                <path
                  d="M302.5 162.664C357.741 162.656 402.559 137.271 402.524 81.3338C402.559 25.3929 357.741 0.0078048 302.5 0C247.259 0.0078048 202.441 25.3929 202.476 81.3299C202.441 137.271 247.259 162.656 302.5 162.66V162.664ZM307.225 60.6589L326.041 41.7908C329.49 43.8591 332.643 46.3644 335.426 49.2366L316.793 67.9173H346.446C347.598 71.7066 348.275 75.6987 348.403 79.8353H315.154C310.608 79.8353 306.54 77.1114 304.8 72.9007C303.057 68.6861 304.01 63.8823 307.229 60.6589H307.225ZM303.909 94.0517C303.909 89.4937 306.63 85.4157 310.826 83.6713C315.03 81.9231 319.821 82.8791 323.04 86.1064L341.891 105.006C339.828 108.459 337.322 111.616 334.449 114.399L315.797 95.6985V125.415C312.017 126.563 308.031 127.234 303.909 127.355V94.0556V94.0517ZM270.508 48.3L289.083 66.9222V37.2874C292.862 36.1284 296.844 35.4494 300.97 35.3167V68.569C300.97 73.1271 298.253 77.2051 294.053 78.9494C292.66 79.5309 291.196 79.8119 289.752 79.8119C286.841 79.8119 283.992 78.6724 281.843 76.5182L263.078 57.7048C265.141 54.2472 267.643 51.0863 270.508 48.3V48.3ZM289.733 82.7816C294.283 82.7816 298.347 85.5094 300.087 89.7161C301.831 93.9307 300.877 98.7346 297.662 101.962L278.861 120.807C275.42 118.734 272.271 116.221 269.496 113.345L288.09 94.6995H258.539C257.391 90.9103 256.717 86.9181 256.593 82.7816H289.729H289.733Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M442.405 218.378V265.769H457.158V218.413C454.97 219.233 452.506 219.67 449.828 219.67C447.15 219.67 444.616 219.221 442.405 218.378Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M40.7109 225.227L29.4851 223.194C20.8284 221.434 17.041 219.127 17.041 215.194C17.041 210.179 22.8563 205.703 30.5672 205.703C39.3602 205.703 45.9851 210.316 46.9349 216.825L60.1886 213.84C57.8882 202.316 46.1214 194.312 30.8397 194.312C14.7445 194.312 3.51875 203.128 3.51875 216.142C3.51875 226.854 9.87509 232.552 24.4834 235.397L35.5729 237.297C46.2576 239.057 50.9908 242.042 50.9908 246.515C50.9908 252.481 43.6886 256.684 34.0821 256.684C22.8563 256.684 14.7406 250.717 13.7948 242.175L0 244.345C0.541047 251.806 3.92357 257.769 10.2799 261.972C16.6362 266.175 24.3471 268.345 33.6773 268.345C51.5318 268.345 64.6493 258.717 64.6493 245.297C64.6493 234.448 57.6157 228.482 40.7109 225.227Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M145.588 252.075H145.452L128.684 196.888H112.316L95.816 251.806H95.6797L79.7208 196.888H64.7077L86.7544 265.769H104.741L120.295 212.076H120.564L136.663 265.769H154.514L176.292 196.888H161.411L145.588 252.075Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
                <path
                  d="M236.34 207.327H236.208C230.257 199.057 221.736 194.308 211.456 194.308C192.251 194.308 178.047 209.902 178.047 231.326C178.047 252.751 192.383 268.345 211.456 268.345C221.872 268.345 230.393 263.599 236.208 255.057H236.344V265.769H250.68V196.888H236.344V207.327H236.34ZM214.699 255.33C202.254 255.33 192.652 245.028 192.652 231.33C192.652 217.633 202.118 207.331 214.699 207.331C227.279 207.331 236.881 217.906 236.881 231.33C236.881 244.755 227.551 255.33 214.699 255.33Z"
                  className={cls('fill-current', {
                    'text-cloud-900': color === 'black',
                    'text-white': color === 'white',
                    'text-kiwi-400': color === 'color',
                  })}
                />
              </>
            )}
            <path
              d="M441.674 218.378V265.769H456.402V218.413C454.218 219.233 451.758 219.67 449.085 219.67C446.411 219.67 443.882 219.221 441.674 218.378Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M40.6436 225.227L29.4364 223.194C20.794 221.434 17.0129 219.127 17.0129 215.194C17.0129 210.179 22.8186 205.703 30.5167 205.703C39.2952 205.703 45.9091 210.316 46.8573 216.825L60.0891 213.84C57.7925 202.316 46.0451 194.312 30.7887 194.312C14.7201 194.312 3.51294 203.128 3.51294 216.142C3.51294 226.854 9.85877 232.552 24.4429 235.397L35.5141 237.297C46.1811 239.057 50.9065 242.042 50.9065 246.515C50.9065 252.481 43.6164 256.684 34.0258 256.684C22.8186 256.684 14.7163 250.717 13.772 242.175L0 244.345C0.540153 251.806 3.91708 257.769 10.2629 261.972C16.6087 266.175 24.3069 268.345 33.6216 268.345C51.4467 268.345 64.5425 258.717 64.5425 245.297C64.5425 234.448 57.5205 228.482 40.6436 225.227Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M145.348 252.075H145.212L128.471 196.888H112.13L95.6576 251.806H95.5216L79.589 196.888H64.6007L86.611 265.769H104.568L120.097 212.076H120.365L136.437 265.769H154.258L176 196.888H161.144L145.348 252.075Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M235.95 207.327H235.818C229.876 199.057 221.37 194.308 211.107 194.308C191.933 194.308 177.753 209.902 177.753 231.326C177.753 252.751 192.065 268.345 211.107 268.345C221.506 268.345 230.012 263.595 235.818 255.057H235.954V265.769H250.266V196.888H235.954V207.327H235.95ZM214.344 255.33C201.92 255.33 192.333 245.028 192.333 231.33C192.333 217.633 201.784 207.331 214.344 207.331C226.903 207.331 236.49 217.906 236.49 231.33C236.49 244.755 227.175 255.33 214.344 255.33Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M302.117 194.308C291.722 194.308 283.215 199.057 277.27 207.732H277.137V196.884H262.825V284.996H277.137V255.19H277.273C283.079 263.732 291.858 268.345 302.253 268.345C321.426 268.345 335.606 252.751 335.606 231.326C335.606 209.902 321.43 194.308 302.12 194.308H302.117ZM299.012 255.33C286.32 255.33 277.001 244.755 277.001 231.33C277.001 217.906 286.32 207.331 299.012 207.331C311.703 207.331 321.022 217.637 321.022 231.33C321.022 245.024 311.567 255.33 299.012 255.33Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M350.05 251.623C344.245 251.623 340.328 255.556 340.328 261.117C340.328 266.678 344.513 270.745 350.05 270.745C355.588 270.745 359.773 266.674 359.773 261.117C359.773 255.56 355.856 251.623 350.05 251.623Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M413.509 196.888L388.164 226.768V177.707H373.448V265.769H388.164V235.892L413.509 265.769H431.928L402.352 231.33L431.928 196.888H413.509Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M546.619 252.075H546.487L529.743 196.888H513.406L496.929 251.806H496.797L480.861 196.888H465.872L487.883 265.769H505.844L521.368 212.076H521.64L537.709 265.769H555.534L577.272 196.888H562.42L546.619 252.075Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M449.085 192.607C443.4 192.607 439.568 196.458 439.568 201.898C439.568 207.338 443.4 211.323 449.085 211.323C454.77 211.323 458.602 207.604 458.602 201.898C458.602 196.193 454.77 192.607 449.085 192.607Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M587.073 218.378V265.769H601.8V218.413C599.617 219.233 597.157 219.67 594.483 219.67C591.81 219.67 589.28 219.221 587.073 218.378Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
            <path
              d="M594.483 211.323C600.165 211.323 604 207.604 604 201.898C604 196.193 600.168 192.607 594.483 192.607C588.798 192.607 584.966 196.458 584.966 201.898C584.966 207.338 588.798 211.323 594.483 211.323Z"
              className={cls('fill-current', {
                'text-cloud-900': color === 'black',
                'text-white': color === 'white',
                'text-kiwi-400': color === 'color',
              })}
            />
          </g>
        </svg>
      )}
      {onlySymbol && style === LogoStyles.OUTLINE && (
        <svg
          width={height ? (height * 200) / 163 : (24 * 200) / 163}
          height={height ? height : 24}
          viewBox="0 0 200 163"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M112.488 79.555H145.682C145.554 75.433 144.878 71.451 143.727 67.6789H114.124L132.726 49.0637C129.948 46.2016 126.8 43.7051 123.357 41.644L104.572 60.4459C101.358 63.658 100.406 68.445 102.147 72.6448C103.884 76.8446 107.941 79.555 112.484 79.555H112.488Z"
            className={cls('fill-current', {
              'text-cloud-900': color === 'black',
              'text-white': color === 'white',
              'text-kiwi-400': color === 'color',
            })}
          />
          <path
            d="M87.1317 79.528C88.5734 79.528 90.0345 79.248 91.4257 78.6686C95.6226 76.9304 98.3311 72.8705 98.3311 68.3246V35.1929C94.212 35.3251 90.2327 36.0017 86.4633 37.1567V66.6914L67.9193 48.1345C65.0593 50.911 62.5606 54.0609 60.501 57.5063L79.2354 76.2537C81.3804 78.4003 84.2289 79.5358 87.1317 79.5358V79.528Z"
            className={cls('fill-current', {
              'text-cloud-900': color === 'black',
              'text-white': color === 'white',
              'text-kiwi-400': color === 'color',
            })}
          />
          <path
            d="M113.133 95.3588L131.755 113.993C134.622 111.221 137.125 108.075 139.185 104.633L120.365 85.8003C117.151 82.5844 112.367 81.6316 108.171 83.3738C103.978 85.112 101.265 89.1718 101.265 93.7177V126.9C105.38 126.78 109.364 126.111 113.133 124.967V95.3549V95.3588Z"
            className={cls('fill-current', {
              'text-cloud-900': color === 'black',
              'text-white': color === 'white',
              'text-kiwi-400': color === 'color',
            })}
          />
          <path
            d="M85.4725 94.3673L66.9091 112.948C69.6798 115.814 72.8236 118.318 76.2588 120.383L95.0281 101.604C98.2379 98.3882 99.19 93.6012 97.4491 89.4014C95.7121 85.2055 91.659 82.4912 87.1123 82.4912H54.0309C54.1552 86.6132 54.8275 90.5953 55.9739 94.3673H85.4764H85.4725Z"
            className={cls('fill-current', {
              'text-cloud-900': color === 'black',
              'text-white': color === 'white',
              'text-kiwi-400': color === 'color',
            })}
          />
          <path
            d="M99.8584 162.093C155.008 162.085 199.752 136.789 199.717 81.0484C199.752 25.3038 155.008 0.00777741 99.8584 0C44.7084 0.00777741 -0.0349535 25.3038 2.04893e-05 81.0445C-0.0349535 136.789 44.7084 162.085 99.8584 162.089V162.093ZM33.8393 25.891C49.9467 14.046 72.773 7.78519 99.8584 7.7813C126.944 7.7813 149.77 14.046 165.878 25.891C183.186 38.6226 191.956 57.1756 191.941 81.0523C191.956 104.917 183.186 123.474 165.878 136.202C149.77 148.047 126.94 154.308 99.8584 154.312C72.773 154.312 49.9428 148.047 33.8393 136.202C16.531 123.47 7.76035 104.917 7.7759 81.0406C7.76035 57.1756 16.531 38.6187 33.8393 25.891Z"
            className={cls('fill-current', {
              'text-cloud-900': color === 'black',
              'text-white': color === 'white',
              'text-kiwi-400': color === 'color',
            })}
          />
        </svg>
      )}
      {onlySymbol && style === LogoStyles.KNOCKOUT && (
        <svg
          width={height ? (height * 200) / 163 : (24 * 200) / 163}
          height={height ? height : 24}
          viewBox="0 0 200 163"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M100.024 162.093C155.265 162.085 200.083 136.789 200.047 81.0484C200.083 25.3038 155.265 0.00777741 100.024 0C44.7824 0.00777741 -0.0350113 25.3038 2.05232e-05 81.0445C-0.0350113 136.789 44.7824 162.085 100.024 162.089V162.093ZM104.749 60.4461L123.565 41.6442C127.014 43.7052 130.167 46.2017 132.95 49.0638L114.317 67.679H143.969C145.121 71.455 145.799 75.4331 145.927 79.5552H112.678C108.132 79.5552 104.064 76.8408 102.324 72.6449C100.58 68.4451 101.534 63.6581 104.753 60.4461H104.749ZM101.433 93.7217C101.433 89.1797 104.154 85.116 108.35 83.3778C112.553 81.6356 117.345 82.5883 120.564 85.8043L139.415 104.637C137.352 108.079 134.845 111.225 131.973 113.997L113.32 95.3627V124.975C109.541 126.119 105.555 126.787 101.433 126.908V93.7256V93.7217ZM68.0319 48.1305L86.6065 66.6874V37.1566C90.3861 36.0016 94.368 35.325 98.494 35.1928V68.3285C98.494 72.8705 95.7771 76.9342 91.5772 78.6724C90.1837 79.2518 88.7201 79.5318 87.276 79.5318C84.3645 79.5318 81.5153 78.3963 79.3666 76.2498L60.6012 57.5023C62.6642 54.0569 65.1671 50.9071 68.0319 48.1305ZM87.2566 82.4911C91.8068 82.4911 95.8705 85.2093 97.6104 89.4014C99.3542 93.6012 98.4006 98.3882 95.1854 101.604L76.385 120.383C72.9441 118.318 69.7951 115.813 67.0198 112.947L85.614 94.3672H56.0627C54.9144 90.5913 54.241 86.6132 54.1165 82.4911H87.2527H87.2566Z"
            className={cls('fill-current', {
              'text-cloud-900': color === 'black',
              'text-white': color === 'white',
              'text-kiwi-400': color === 'color',
            })}
          />
        </svg>
      )}
      {!onlySymbol && style === LogoStyles.APP && (
        <svg
          width={height ? (height * 874) / 122 : (24 * 874) / 122}
          height={height ? height : 24}
          viewBox="0 0 874 122"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M185.258 0H60.502C27.0867 0 0 27.0867 0 60.502C0 93.9172 27.0867 121.004 60.502 121.004H185.258C218.673 121.004 245.76 93.9172 245.76 60.502C245.76 27.0867 218.673 0 185.258 0Z"
            fill="#32D583"
          />
          <path
            d="M718.059 48.8364C715.334 48.8364 712.832 48.3875 710.614 47.5442V94.9557H725.411V47.5793C723.216 48.3992 720.745 48.8364 718.059 48.8364Z"
            fill="#161421"
          />
          <path
            d="M277.192 91.1609C270.816 86.9561 267.424 80.9868 266.881 73.526L280.717 71.3553C281.666 79.9014 289.806 85.8708 301.065 85.8708C310.697 85.8708 318.025 81.6661 318.025 75.6967C318.025 71.2187 313.277 68.2359 302.56 66.4752L291.438 64.5739C276.786 61.7278 270.41 56.0278 270.41 45.311C270.41 32.2869 281.67 23.4714 297.813 23.4714C313.957 23.4714 324.943 31.4749 327.25 43.0076L313.957 45.9942C313.004 39.4822 306.359 34.8675 297.54 34.8675C289.806 34.8675 283.973 39.3455 283.973 44.3623C283.973 48.2977 287.772 50.605 296.454 52.3657L307.714 54.3998C324.673 57.6558 331.724 63.6252 331.724 74.4786C331.724 87.9048 318.563 97.5363 300.659 97.5363C291.297 97.5363 283.567 95.3656 277.192 91.1609Z"
            fill="#161421"
          />
          <path
            d="M331.783 26.0443H346.841L362.848 80.9868H362.984L379.534 26.0443H395.951L412.77 81.2562H412.906L428.78 26.0443H443.702L421.862 94.9557H403.954L387.811 41.2352H387.541L371.94 94.9557H353.896L331.783 26.0443Z"
            fill="#161421"
          />
          <path
            d="M445.467 60.5019C445.467 39.0683 459.713 23.4675 478.975 23.4675C489.286 23.4675 497.832 28.2149 503.802 36.4916H503.934V26.0481H518.313V94.9556H503.934V84.2389H503.798C497.965 92.785 489.419 97.5324 478.972 97.5324C459.845 97.5324 445.463 81.9315 445.463 60.498L445.467 60.5019ZM504.477 60.5019C504.477 47.0718 495.119 36.4916 482.228 36.4916C469.336 36.4916 460.115 47.0718 460.115 60.5019C460.115 73.932 469.746 84.5122 482.228 84.5122C494.709 84.5122 504.477 73.932 504.477 60.5019Z"
            fill="#161421"
          />
          <path
            d="M530.931 26.0442H545.31V36.8977H545.443C551.412 28.2149 559.958 23.4675 570.406 23.4675C589.805 23.4675 604.047 39.0683 604.047 60.5019C604.047 81.9354 589.805 97.5363 570.539 97.5363C560.095 97.5363 551.276 92.9216 545.443 84.3755H545.306V114.195H530.927V26.0442H530.931ZM589.399 60.5019C589.399 46.8024 579.768 36.4916 567.286 36.4916C554.805 36.4916 545.174 47.0718 545.174 60.5019C545.174 73.932 554.536 84.5122 567.286 84.5122C580.037 84.5122 589.399 73.932 589.399 60.5019Z"
            fill="#161421"
          />
          <path
            d="M608.799 90.302C608.799 84.7387 612.73 80.8033 618.567 80.8033C624.404 80.8033 628.335 84.7387 628.335 90.302C628.335 95.8654 624.13 99.9335 618.567 99.9335C613.004 99.9335 608.799 95.8615 608.799 90.302Z"
            fill="#161421"
          />
          <path
            d="M700.826 26.0443H682.321L652.97 60.502L682.321 94.9557H700.826L671.112 60.502L700.826 26.0443Z"
            fill="#161421"
          />
          <path
            d="M734.929 26.0443H749.987L765.994 80.9868H766.126L782.676 26.0443H799.089L815.912 81.2562H816.044L831.918 26.0443H846.84L825 94.9557H807.092L790.949 41.2352H790.675L775.075 94.9557H757.03L734.917 26.0443H734.929Z"
            fill="#161421"
          />
          <path
            d="M708.502 31.0611C708.502 25.6148 712.351 21.7654 718.063 21.7654C723.771 21.7654 727.624 25.6187 727.624 31.0611C727.624 36.7689 723.775 40.4895 718.063 40.4895C712.351 40.4895 708.502 36.7689 708.502 31.0611Z"
            fill="#161421"
          />
          <path d="M656.858 6.85559H642.07V94.9596H656.858V6.85559Z" fill="#161421" />
          <path
            d="M864.135 48.8364C861.41 48.8364 858.907 48.3875 856.69 47.5442V94.9557H871.486V47.5793C869.292 48.3992 866.821 48.8364 864.135 48.8364Z"
            fill="#161421"
          />
          <path
            d="M854.578 31.0611C854.578 25.6148 858.427 21.7654 864.139 21.7654C869.847 21.7654 873.7 25.6187 873.7 31.0611C873.7 36.7689 869.851 40.4895 864.139 40.4895C858.427 40.4895 854.578 36.7689 854.578 31.0611Z"
            fill="#161421"
          />
          <path
            d="M50.4995 59.5962C50.4995 46.1895 59.4087 36.4292 71.4568 36.4292C77.9063 36.4292 83.2511 39.4002 86.9834 44.5771H87.0693V38.0416H96.2322V81.1469H87.2294L87.2372 74.4435H87.1513C83.5009 79.7882 77.9883 82.7592 71.4529 82.7592C59.4868 82.7592 50.4956 73.0029 50.4956 59.5923L50.4995 59.5962ZM87.4128 59.5962C87.4128 51.1945 81.5567 44.5771 73.4947 44.5771C65.4327 44.5771 59.6625 51.1945 59.6625 59.5962C59.6625 67.9978 65.6865 74.6153 73.4947 74.6153C81.3029 74.6153 87.4128 67.9978 87.4128 59.5962Z"
            fill="#161421"
          />
          <path
            d="M100.816 38.0416H109.725L109.811 44.8308H109.897C113.629 39.4002 118.978 36.4292 125.509 36.4292C137.643 36.4292 146.552 46.1856 146.552 59.5962C146.552 73.0068 137.643 82.7631 125.595 82.7631C119.06 82.7631 113.801 79.878 110.15 74.5333H110.065V95.0377H100.816V38.0416ZM137.389 59.5962C137.389 51.0267 131.365 44.5771 123.557 44.5771C115.749 44.5771 109.725 51.1945 109.725 59.5962C109.725 67.9978 115.581 74.6153 123.557 74.6153C131.533 74.6153 137.389 67.9978 137.389 59.5962Z"
            fill="#161421"
          />
          <path
            d="M149.523 38.0416H158.432L158.518 44.8308H158.604C162.337 39.4002 167.685 36.4292 174.217 36.4292C186.351 36.4292 195.26 46.1856 195.26 59.5962C195.26 73.0068 186.351 82.7631 174.303 82.7631C167.767 82.7631 162.508 79.878 158.858 74.5333H158.772V95.0377H149.523V38.0416ZM186.097 59.5962C186.097 51.0267 180.073 44.5771 172.265 44.5771C164.457 44.5771 158.432 51.1945 158.432 59.5962C158.432 67.9978 164.289 74.6153 172.265 74.6153C180.241 74.6153 186.097 67.9978 186.097 59.5962Z"
            fill="#161421"
          />
        </svg>
      )}
      {onlySymbol && style === LogoStyles.APP && (
        <svg
          width={height ? (height * 415) / 121 : (24 * 415) / 121}
          height={height ? height : 24}
          viewBox="0 0 415 121"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g clipPath="url(#clip0_6816_46344)">
            <path
              d="M339.574 0C298.377 0.00389908 264.954 18.8871 264.981 60.4981C264.954 102.109 298.377 120.992 339.574 120.996C380.772 120.992 414.195 102.109 414.168 60.4981C414.195 18.8871 380.772 0.00389908 339.574 0ZM335.964 75.8487L321.943 89.8659C319.377 88.3258 317.026 86.4542 314.96 84.3175L328.829 70.4446H306.791C305.933 67.6256 305.434 64.6545 305.341 61.5781H330.053C333.449 61.5781 336.479 63.6056 337.773 66.7366C339.071 69.8714 338.362 73.4469 335.964 75.8487ZM338.436 51.0038C338.436 54.396 336.412 57.4295 333.277 58.724C332.236 59.1568 331.149 59.3634 330.069 59.3634C327.897 59.3634 325.772 58.5173 324.169 56.9148L310.175 42.921C311.716 40.3476 313.583 37.9965 315.716 35.9261L329.569 49.7795V27.7341C332.388 26.8724 335.36 26.3694 338.436 26.2681V51.0038ZM363.406 85.0934L349.494 71.1815V93.2854C346.675 94.1393 343.704 94.6384 340.627 94.728V69.9572C340.627 66.565 342.655 63.5315 345.786 62.237C348.921 60.9386 352.496 61.6483 354.898 64.0501L368.954 78.1063C367.414 80.6758 365.546 83.023 363.406 85.0934ZM349.01 59.3829C345.618 59.3829 342.585 57.3593 341.29 54.2244C339.992 51.0896 340.701 47.5141 343.103 45.1162L357.136 31.0834C359.709 32.6236 362.06 34.4873 364.135 36.6201L350.238 50.5164H372.35C373.208 53.3355 373.715 56.3065 373.808 59.3829H349.01Z"
              fill="#161421"
            />
            <path
              d="M185.019 0.0701904H60.4279C27.0518 0.0701904 0 27.122 0 60.4942C0 93.8663 27.0518 120.918 60.424 120.918H185.019C218.391 120.918 245.443 93.8663 245.443 60.4942C245.443 27.122 218.391 0.0701904 185.019 0.0701904Z"
              fill="#32D583"
            />
            <path
              d="M50.4346 59.5895C50.4346 46.2001 59.3323 36.4524 71.3648 36.4524C77.8061 36.4524 83.1439 39.4196 86.8714 44.5898H86.9572V38.0627H96.1083V81.1124H87.1171L87.1249 74.4177H87.0391C83.3934 79.7555 77.888 82.7227 71.3609 82.7227C59.4102 82.7227 50.4307 72.9789 50.4307 59.5856L50.4346 59.5895ZM87.3003 59.5895C87.3003 51.1987 81.4517 44.5898 73.4001 44.5898C65.3485 44.5898 59.5857 51.1987 59.5857 59.5895C59.5857 67.9803 65.602 74.5893 73.4001 74.5893C81.1983 74.5893 87.3003 67.9803 87.3003 59.5895Z"
              fill="#161421"
            />
            <path
              d="M100.686 38.0627H109.583L109.669 44.8432H109.755C113.483 39.4196 118.824 36.4524 125.347 36.4524C137.466 36.4524 146.363 46.1962 146.363 59.5895C146.363 72.9828 137.466 82.7266 125.433 82.7266C118.906 82.7266 113.654 79.8452 110.008 74.5074H109.923V94.9853H100.686V38.0627ZM137.212 59.5895C137.212 51.031 131.196 44.5898 123.398 44.5898C115.6 44.5898 109.583 51.1987 109.583 59.5895C109.583 67.9803 115.432 74.5893 123.398 74.5893C131.364 74.5893 137.212 67.9803 137.212 59.5895Z"
              fill="#161421"
            />
            <path
              d="M149.331 38.0627H158.228L158.314 44.8432H158.4C162.127 39.4196 167.469 36.4524 173.992 36.4524C186.111 36.4524 195.008 46.1962 195.008 59.5895C195.008 72.9828 186.111 82.7266 174.078 82.7266C167.551 82.7266 162.299 79.8452 158.653 74.5074H158.568V94.9853H149.331V38.0627ZM185.857 59.5895C185.857 51.031 179.841 44.5898 172.043 44.5898C164.245 44.5898 158.228 51.1987 158.228 59.5895C158.228 67.9803 164.077 74.5893 172.043 74.5893C180.009 74.5893 185.857 67.9803 185.857 59.5895Z"
              fill="#161421"
            />
          </g>
          <defs>
            <clipPath id="clip0_6816_46344">
              <rect width="414.168" height="121" fill="white" />
            </clipPath>
          </defs>
        </svg>
      )}
    </>
  );
};
